<template>
    <div class="payment-card">
        <div class="payment-card__body">
            <p>{{ $t("payment.statuses.accepted.flow-from-bromoney.card.title") }} {{ payment.amountFromWallet }} $</p>
            <p>{{ $t("payment.statuses.accepted.flow-from-bromoney.card.text") }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
import {PropType, toRef} from "vue";
import PurchaseOperation from "@models/operations/PurchaseOperation";
import {f7} from "framework7-vue";
import {ToRef} from "@vue/runtime-core";
import {useTranslate} from "@tolgee/vue";

const props = defineProps({
    payment: {
        type: Object as PropType<PurchaseOperation>,
        required: true
    }
});

const {t} = useTranslate();
const payment: ToRef<PurchaseOperation> = toRef(props, 'payment');

function copy(value: string) {
    const aux = document.createElement("input");
    aux.setAttribute("value", value);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);

    f7.toast.create({
        text: t.value('g.copied'),
        position: 'top',
        closeTimeout: 1000,
    }).open();
}
</script>

<style scoped lang="scss">
.payment-card {
    width: 100%;
    //height: 197px;
    border-radius: 18px;
    box-sizing: border-box;
    padding: 20px;
    background-color: var(--grey9);
    border: 0.5px solid var(--grey8);
    display: flex;
    flex-direction: column;

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .amount {
            display: flex;
            align-items: center;
            gap: 8px;

            p {
                @include text(24px, 700, var(--brown1), 28.8px);
            }

            i {
                cursor: pointer;
            }
        }
    }

    &__body {
        flex: 1;
        display: flex;
        flex-direction: column;

        p:nth-child(1) {
            @include text(14px, 400, var(--brown1), 120%);
        }

        p:nth-child(2) {
            margin-top: 16px;
            @include text(14px, 400, var(--grey2), 120%);
        }
    }
}
</style>
